var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn_blue",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickReviewButton($event)}}},[_vm._v("Оставить отзыв")])}
var staticRenderFns = []

export { render, staticRenderFns }